var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLOR_TOKENS } from '@backrs_ui/common-ui/src/designSystem/colors/colors';
import { Box } from '@mui/material';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
var FIGMA_CHART_DIAMETER = 120;
var FIGMA_MULTI_CHART_DIAMETER = 240;
ChartJS.register(ArcElement, Tooltip);
var defaultOptions = function (isTooltipEnabled, cutout) { return ({
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 1,
    cutout: cutout,
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            enabled: isTooltipEnabled,
            callbacks: {
                label: function (context) {
                    var label = context.label || '';
                    var value = context.parsed;
                    return "".concat(label, ": ").concat(value, "%");
                },
            },
        },
    },
    rotation: (-90 * Math.PI) / 180,
}); };
var getChartSize = function (size) {
    if (typeof size === 'number')
        return size;
    switch (size) {
        case 'xsmall':
            return 80;
        case 'small':
            return FIGMA_CHART_DIAMETER;
        case 'medium':
            return 180;
        case 'large':
            return FIGMA_MULTI_CHART_DIAMETER;
        default:
            return 240;
    }
};
export var DonutChart = function (_a) {
    var variant = _a.variant, _b = _a.size, size = _b === void 0 ? 'small' : _b, _c = _a.isTooltipEnabled, isTooltipEnabled = _c === void 0 ? true : _c, _d = _a.cutout, cutout = _d === void 0 ? '50%' : _d;
    if (variant.type === 'solo') {
        var safeValue = Math.min(100, Math.max(0, variant.percentageFilled));
        var chartData_1 = {
            datasets: [
                __assign({ data: [safeValue, 100 - safeValue], backgroundColor: [
                        COLOR_TOKENS['Colors/Border/border-brand'],
                        COLOR_TOKENS['Colors/Border/border-secondary'],
                    ], borderColor: COLOR_TOKENS['Colors/Base/Black'], borderWidth: 1, borderRadius: 0 }, (!isTooltipEnabled && {
                    hoverBackgroundColor: [
                        COLOR_TOKENS['Colors/Border/border-brand'],
                        COLOR_TOKENS['Colors/Border/border-secondary'],
                    ],
                })),
            ],
        };
        var chartSize_1 = getChartSize(size);
        return (_jsx(Box, { sx: { width: "".concat(chartSize_1, "px"), height: "".concat(chartSize_1, "px") }, children: _jsx(Doughnut, { data: chartData_1, options: defaultOptions(isTooltipEnabled, cutout) }) }));
    }
    var safeSegments = variant.segments.map(function (s) { return (__assign(__assign({}, s), { value: Math.max(0, Math.min(100, s.value)) })); });
    var total = safeSegments.reduce(function (sum, seg) { return sum + seg.value; }, 0);
    var chartSegments = __spreadArray([], safeSegments, true);
    if (total < 100) {
        chartSegments.push({
            label: 'Remaining',
            value: 100 - total,
            color: 'Colors/Border/border-secondary',
        });
    }
    var chartData = {
        labels: chartSegments.map(function (s) { return s.label; }),
        datasets: [
            __assign({ data: chartSegments.map(function (s) { return s.value; }), backgroundColor: chartSegments.map(function (s) { return COLOR_TOKENS[s.color]; }), borderColor: COLOR_TOKENS['Colors/Base/Black'], borderWidth: 1, borderRadius: 0 }, (!isTooltipEnabled && {
                hoverBackgroundColor: chartSegments.map(function (s) { return COLOR_TOKENS[s.color]; }),
            })),
        ],
    };
    var chartSize = getChartSize(size);
    return (_jsx(Box, { sx: { width: "".concat(chartSize, "px"), height: "".concat(chartSize, "px") }, children: _jsx(Doughnut, { data: chartData, options: defaultOptions(isTooltipEnabled, cutout) }) }));
};
